import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  box-shadow: ${({ theme }) => theme.shadowBox.menu};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const OptionsList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const OptionsItem = styled.li`
  padding: ${({ theme }) => theme.spacing(1)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[400]};

  &:last-child {
    border-bottom: none;
  }
`;

export const OptionDescription = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const OptionPremiumLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: block;

  margin-top: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};

  background: ${({ theme }) => theme.palette.info.light};
  border-radius: ${({ theme }) => theme.spacing(6)};

  color: ${({ theme }) => theme.palette.info.main};
`;

export const OptionContainer = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: ${({ theme }) =>
    `${theme.spacing(1.5)} ${theme.spacing(0.5)} ${theme.spacing(1.5)} ${theme.spacing(3)}`};
  width: 100%;

  border: none;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: transparent;
  transition: background 200ms;
  cursor: pointer;

  text-align: left;
  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
  }
`;

export const OptionContent = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
